<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_slots')"
                        :isNewButton="checkPermission('studentslot_store')"
                        @new-button-click="createFormShow"
                        :isFilter="true"
                        @filter-div-status="filterStatus=$event"
                        :isExpandAll="!expandAllStatus"
                        :isCollapseAll="expandAllStatus"
                        @expand-all="expandAll"
                        @collapse-all="collapseAll"
                        :is-cancel-to-move="moveMode"
                        @move-cancel="moveCancel"
                />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_slots')"
                              :isNewButton="checkPermission('studentslot_store')"
                              @new-button-click="createFormShow"
                              :isFilter="true"
                              @filter-div-status="filterStatus=$event"
                              :isExpandAll="!expandAllStatus"
                              :isCollapseAll="expandAllStatus"
                              @expand-all="expandAll"
                              @collapse-all="collapseAll"
                              :is-cancel-to-move="moveMode"
                              @move-cancel="moveCancel"
                />
            </template>
            <div class="spinner over text-center" v-if="loading">
                <b-spinner label="Spinning" variant="primary"></b-spinner>
            </div>
            <div v-else>
                <!-- Info -->
                <div class="mb-2 d-flex">
                    <b-button variant="light"
                              class="border w-40 h-40 mr-2"
                              :class="showExtraStudentInfo ? null : 'collapsed'"
                              :aria-expanded="showExtraStudentInfo ? 'true' : 'false'"
                              aria-controls="collapse-4"
                              @click="showExtraStudentInfo = !showExtraStudentInfo"
                    >
                        <i class="ri-arrow-down-s-line" v-if="!showExtraStudentInfo"></i>
                        <i class="ri-arrow-up-s-line" v-if="showExtraStudentInfo"></i>
                    </b-button>
                    <div
                        class="flex-grow-1 bg-light w-40 h-40 border rounded-sm d-flex align-items-center pl-3 font-weight-bold">
                        {{ getObjectValue(student, 'student_number') }},
                        {{ getObjectValue(student, 'name') }}
                        {{ getObjectValue(student, 'surname') }}
                    </div>
                </div>
                <b-collapse id="collapse-4" v-model="showExtraStudentInfo">
                    <div class="border rounded-sm p-4 mb-4">
                        <b-row>
                            <b-col cols="auto">
                                <b-form-group :label="$t('faculty')">
                                    <div class="label-as-input">
                                        {{ student.program }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('program')">
                                    <div class="label-as-input">
                                        {{ student.program }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('registration_type')">
                                    <div class="label-as-input">
                                        {{ student.registration_type }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('registration_academic_year')">
                                    <div class="label-as-input">
                                        {{ student.registration_season }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('number_of_semesters')">
                                    <div class="label-as-input">
                                        {{ student.semester_count }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('semester_statuses')">
                                    <div class="label-as-input">
                                        {{ student.semester_status }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto">
                                <b-form-group :label="$t('student_status')">
                                    <div class="label-as-input">
                                        {{ student.student_status }}
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </b-collapse>
                <b-row class="infos">
                    <b-col cols="6" md="3">
                        <div class="bg-white border rounded-sm text-center p-2 mb-3">
                            <label>{{ $t('gno') }} </label>
                            <h3 style="margin-bottom: 5px;">{{ student.cgpa ? student.cgpa : '-' }}</h3>
                        </div>
                    </b-col>
                    <b-col cols="6" md="3">
                        <div class="bg-white border rounded-sm mb-3">
                            <div class="text-center p-2">
                                <label class="d-block d-lg-none">{{ $t('credit') }}</label>
                                <label class="d-none d-lg-block">{{ $t('credits_attempted') }} / {{
                                        $t('total_credits')
                                    }} </label>
                                <h3 class="mb-0">{{ student.completed_credits }} / {{ totalCredits(student.not_completed_credits,student.completed_credits) }}</h3>
                            </div>
                            <b-progress :value="student.completed_credits"
                                        :max="student.total_credits"
                                        height="5px"
                            />
                        </div>
                    </b-col>

                    <b-col cols="6" md="3">
                        <div class="bg-white border rounded-sm mb-3">
                            <div class="text-center p-2">
                                <label class="d-block d-lg-none">{{ $t('slot') }}</label>
                                <label class="d-none d-lg-block">{{ $t('completed_slots') }} / {{
                                        $t('total_slots')
                                    }} </label>
                                <h3 class="mb-0">{{ student.completed_slots }} / {{ student.total_slots }} </h3>
                            </div>
                            <b-progress :value="student.completed_slots"
                                        :max="student.total_slots"
                                        height="5px"
                            />
                        </div>
                    </b-col>
                </b-row>

                <!-- Filter -->
                <div class="filter" v-show="filterStatus">
                    <h6>{{ $t('filter1') }}</h6>
                    <div class="border rounded p-4 pb-0 mb-4">
                        <b-row>
                            <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 mb-md-0">
                                <b-form-group v-slot="{ ariaDescribedby }" class="mb-1" :label="$t('slot_types')">
                                    <b-form-select v-model="filterSlotType" :options="filterSlotTypes" />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 mb-md-0">
                                <b-form-group v-slot="{ ariaDescribedby }" class="mb-1" :label="$t('status')">
                                    <b-form-select v-model="filterStatusType" :options="filterStatusTypes" />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4" lg="6" class="d-flex align-items-end">
                                <b-button variant="primary" @click="filterSlot" class="flex-fill mr-2">
                                    {{ $t('filter') }}
                                </b-button>
                                <b-button variant="danger" @click="clearFilter" class="flex-fill">
                                    {{ $t('clear') }}
                                </b-button>
                            </b-col>

                        </b-row>
                    </div>
                </div>

                <!-- Slots -->
                <h6>{{ $t('slots') }}</h6>
                <template v-if="semesters && semesters.length > 0">
                    <div v-for="semester in semesters">
                        <div class="border p-3 bg-primary text-light font-weight-bold rounded">
                            {{semester + '. ' + $t('semester')  }}
                        </div>
                        <b-table :empty-filtered-text="$t('no_result')" :empty-text="$t('no_result')" bordered responsive
                                 :items="groupSlot[semester]" :fields="slotsFields" show-empty
                                 class="mb-4 table-dropdown no-scrollbar border rounded" @row-clicked="onRowClicked" foot-clone
                        >
                            <template #cell(process)="data">
                                <b-dropdown class="w-40" variant="link btn-sm" boundary="window" ref="dropdown" no-caret>
                                    <template #button-content>
                                        <i class="ri-more-fill"></i>
                                    </template>
                                    <div id="dropdownList">
                                        <b-dropdown-item v-if="toggleProccessButton('studentslot_update', data.item)"
                                                         @click="updateFormShow(data.item.id)">
                                    <span>
                                        <i class="ri-pencil-fill align-middle top-minus-1 mr-3 text-muted"></i>
                                        {{ $t('edit') }}
                                    </span>
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="toggleProccessButton('studentslot_delete', data.item)"
                                                         @click="deleteForm(data.item.id)">
                                    <span>
                                        <i class="ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted align-middle top-minus-1 mr-3 text-muted"></i>
                                        {{ $t('delete') }}
                                    </span>
                                        </b-dropdown-item>
                                    </div>
                                </b-dropdown>
                            </template>
                            <template #cell(program_module_name)="{item}">
                                {{decodeHtml(item.program_module_name)}}
                            </template>
                            <template #cell(detail)="data">
                                <div v-if="moveMode">
                                    <b-button variant="success"
                                              class="width-150"
                                              @click="moveHere(data.item.id)"
                                              size="sm"
                                              v-if="data.item.id != moveFromSlotId">
                                        <i class="ri-check-line font-size-16"></i>&nbsp; {{ $t('move_here') }}
                                    </b-button>
                                </div>
                                <div class="w-40 h-40 cursor-pointer d-flex justify-content-center align-items-center" v-else>
                                    <i :class="data.detailsShowing ? 'ri-arrow-up-s-line font-size-20':'ri-arrow-down-s-line font-size-20'"></i>
                                </div>
                            </template>
                            <template #cell(responsive)="data">
                                <b-table-simple class="table-bordered table-striped table-sm">
                                    <b-tbody>
                                        <tr>
                                            <td class="font-weight-bold width-100">{{ $t('semester') }}</td>
                                            <td>{{ data.item.semester }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">{{ $t('slot_type') }}</td>
                                            <td>
                                        <span v-if="data.item.slot_type">
                                            {{ data.item.slot_type.name }}
                                        </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">{{ $t('course_code') }}</td>
                                            <td>
                                        <span>
                                            {{ data.item.course && data.item.course.code ? data.item.course.code : '-' }}
                                        </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">{{ $t('course_name') }}</td>
                                            <td>
                                        <span v-if="data.item.slot_type && data.item.slot_type.code == 'M'">
                                            {{ data.item.course ? data.item.course.name : '-' }}
                                        </span>
                                                <span v-else-if="data.item.slot_type && data.item.slot_type.code == 'P'">
                                            {{ data.item.course ? data.item.course.name : '-' }}
                                        </span>
                                                <span v-else>
                                            {{ data.item.pool ? data.item.pool.name : '-' }}
                                        </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">{{ $t('credit') }}</td>
                                            <td>{{ data.item.credit }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">{{ $t('status') }}</td>
                                            <td>
                                        <span v-if="data.item.slot_status">
                                            <b-badge variant="success" v-if="data.item.slot_status == 1">
                                                {{ $t('success') }}
                                            </b-badge>
                                            <b-badge variant="primary" v-else-if="data.item.slot_status == 2">
                                                {{ $t('taking_during_current_semester') }}
                                            </b-badge>
                                            <b-badge variant="secondary" v-else-if="data.item.slot_status == 3">
                                                {{ $t('unsuccessful') }}
                                            </b-badge>
                                            <b-badge variant="warning" v-else-if="data.item.slot_status == 4">
                                                {{ $t('not_taken') }}
                                            </b-badge>
                                            <b-badge variant="warning" v-else-if="data.item.slot_status==5">
                                                {{ $t('awaiting_grading') }}
                                            </b-badge>
                                        </span>
                                            </td>
                                        </tr>
                                    </b-tbody>
                                </b-table-simple>
                            </template>
                            <template #cell(slot_type)="data">
                        <span v-if="data.item.slot_type">
                            {{ data.item.slot_type.name }}
                        </span>
                            </template>
                            <template #cell(course_code)="data">
                        <span>
                            {{ data.item.course && data.item.course.code ? data.item.course.code : '-' }}
                        </span>
                            </template>
                            <template #cell(course_name)="data">
                                <span v-if="data.item.slot_type && data.item.slot_type.code == 'M'">
                                    {{ data.item.course ? decodeHtml(data.item.course.name) : '-' }}
                                </span>
                                <span v-else-if="data.item.slot_type && data.item.slot_type.code == 'P'">
                                       {{ data.item.course ? decodeHtml(data.item.course.name) : '-' }}
                                </span>
                                <span v-else>
                                    {{ data.item.pool ? decodeHtml(data.item.pool.name): '-' }}
                                </span>
                            </template>
                            <template #cell(status)="data">
                        <span v-if="data.item.slot_status">

                            <b-badge variant="success" v-if="data.item.slot_status == 1">
                                {{ $t('success') }}
                            </b-badge>
                            <b-badge variant="primary" v-else-if="data.item.slot_status == 2">
                                {{ $t('taking_during_current_semester') }}
                            </b-badge>
                            <b-badge variant="secondary" v-else-if="data.item.slot_status == 3">
                                {{ $t('unsuccessful') }}
                            </b-badge>
                            <b-badge variant="warning" v-else-if="data.item.slot_status == 4">
                                {{ $t('not_taken') }}
                            </b-badge>
                            <b-badge variant="warning" v-else-if="data.item.slot_status==5">
                                {{ $t('awaiting_grading') }}
                            </b-badge>
                        </span>

                            </template>
                            <template #row-details="data">
                                <div class="d-flex align-items-center">
                                    <h6 class="ml-2 mr-3 mb-0 mt-0">{{ $t('courses').toUpper() }}</h6>
                                    <b-button class="btn-sm bg-white"
                                              variant="light"
                                              v-if="toggleProccessButton('studentslot_update', data.item)"
                                              @click="createCourseFormShow(data.item.id)">
                                <span>
                                    <i class="ri-add-line top-plus-1 mr-1"></i>
                                    {{ $t('new').toUpper() }}
                                </span>
                                    </b-button>
                                </div>
                                <div class="bg-white m-2" v-if="data.item.courses && data.item.courses.length > 0">
                                    <b-table-simple class="table table-bordered m-0">
                                        <b-thead>
                                            <b-th>&nbsp;</b-th>
                                            <b-th class="d-table-cell d-lg-none">{{ $t('course').toUpper() }}</b-th>
                                            <b-th class="d-none d-lg-table-cell">{{ $t('academic_year').toUpper() }} /
                                                {{ $t('period').toUpper() }}
                                            </b-th>
                                            <b-th class="d-none d-lg-table-cell">{{ $t('course_code').toUpper() }}</b-th>
                                            <b-th class="d-none d-lg-table-cell">{{ $t('course_name').toUpper() }}</b-th>
                                            <b-th class="d-none d-lg-table-cell text-center">{{
                                                    $t('letter_grade').toUpper()
                                                }}
                                            </b-th>
                                            <b-th class="d-none d-lg-table-cell text-center">{{ $t('credit').toUpper() }}</b-th>
<!--
                                            <b-th class="d-none d-lg-table-cell text-center">{{ $t('ects').toUpper() }}</b-th>
-->
                                            <b-th class="d-none d-lg-table-cell text-center">{{
                                                    $t('notexcredit').toUpper()
                                                }}
                                            </b-th>
                                        </b-thead>
                                        <b-tbody>
                                            <b-tr v-for="(course,courseKey) in data.item.courses" :key="'course'+course.id">
                                                <b-td class="w-40 p-1">
                                                    <b-dropdown variant="link w-40" boundary="window" ref="dropdown" no-caret
                                                                v-if="toggleProccessButton('studentslot_update', data.item)">
                                                        <template #button-content>
                                                            <i class="ri-more-fill"></i>
                                                        </template>
                                                        <div id="dropdownList">
                                                            <b-dropdown-item
                                                                @click="updateCourseFormShow(data.item.id, course.id)">
                                                        <span>
                                                            <i class="ri-pencil-fill align-middle top-minus-1 mr-3 text-muted"></i>
                                                            {{ $t('edit') }}
                                                        </span>
                                                            </b-dropdown-item>
                                                            <b-dropdown-item @click="move(data.item.id, course.id)">
                                                        <span>
                                                            <i class="ri-drag-move-2-line align-middle top-minus-1 mr-3 text-muted"></i>
                                                            {{ $t('move') }}
                                                        </span>
                                                            </b-dropdown-item>
                                                            <b-dropdown-item @click="deleteCourseForm(course.id)">
                                                        <span>
                                                            <i class="ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted align-middle top-minus-1 mr-3 text-muted"></i>
                                                            {{ $t('delete') }}
                                                        </span>
                                                            </b-dropdown-item>
                                                        </div>
                                                    </b-dropdown>
                                                </b-td>
                                                <b-td class="d-table-cell d-lg-none">
                                                    <b-table-simple class="table-bordered table-striped table-sm">
                                                        <b-tbody>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">
                                                                    {{ $t('academic_year').toUpper() }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        course.semester && course.semester.academic_year ? course.semester.academic_year : '-'
                                                                    }}
                                                                    /
                                                                    {{
                                                                        course.semester && course.semester.semester ? getSemester(course.semester.semester) : '-'
                                                                    }}

                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">
                                                                    {{ $t('course_code').toUpper() }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        getLocaleText(course, 'course_code') ? getLocaleText(course, 'course_code') : '-'
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">
                                                                    {{ $t('course_name').toUpper() }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        getLocaleText(course, 'course_name') ? getLocaleText(course, 'course_name') : '-'
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">
                                                                    {{ $t('letter_grade').toUpper() }}
                                                                </td>
                                                                <td>
                                                                    {{ course.letter_grade ? course.letter_grade : '-' }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">{{
                                                                        $t('credit').toUpper()
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{ course.credit ? course.credit : 0 }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">{{
                                                                        $t('ects').toUpper()
                                                                    }}
                                                                </td><!--

                                                                <td>
                                                                    {{ course.ects_credit ? course.ects_credit : 0 }}
                                                                </td>-->
                                                            </tr>
                                                            <tr>
                                                                <td class="font-weight-bold width-100">
                                                                    {{ $t('notexcredit').toUpper() }}
                                                                </td>
                                                                <td>
                                                                    {{ parseFloat(course.point * course.credit).toFixed(2) }}
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-td>
                                                <b-td class="d-none d-lg-table-cell align-middle">
                                                    {{
                                                        course.semester && course.semester.academic_year ? course.semester.academic_year : '-'
                                                    }}
                                                    /
                                                    {{
                                                        course.semester && course.semester.semester ? getSemester(course.semester.semester) : '-'
                                                    }}
                                                </b-td>
                                                <b-td class="d-none d-lg-table-cell align-middle">
                                                    <!--                                            {{ course.university_course?.equivalent_course_id ? course.university_course.code + ' | ' + course.course_code : course.course_code }}-->
                                                    {{ getLocaleText(course, 'course_code') ? getLocaleText(course, 'course_code') : '-' }}
                                                </b-td>
                                                <b-td class="d-none d-lg-table-cell align-middle">
                                                    {{
                                                        getLocaleText(course, 'course_name') ? getLocaleText(course, 'course_name') : '-'
                                                    }}
                                                </b-td>
                                                <b-td class="d-none d-lg-table-cell align-middle text-center">
                                                    {{ course.letter_grade ? course.letter_grade : '-' }}
                                                </b-td>
                                                <b-td class="d-none d-lg-table-cell align-middle text-center">
                                                    {{ course.credit ? course.credit : 0 }}
                                                </b-td>
<!--                                                <b-td class="d-none d-lg-table-cell align-middle text-center">
                                                    {{ course.ects_credit ? course.ects_credit : 0 }}
                                                </b-td>-->
                                                <b-td class="d-none d-lg-table-cell align-middle text-center">
                                                    {{ parseFloat(course.point * course.credit).toFixed(2) }}
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </div>
                                <div class="border bg-white rounded-sm p-4 m-2" v-else>
                                    {{ $t('no_course') }}
                                </div>
                            </template>
                            <template #foot(semester)="data">
                                <span></span>
                            </template>
                            <template #foot(program_module_name)="data">
                                <span></span>
                            </template>
                            <template #foot(credit)="data">
                                <p>
                                    {{groupSlot[semester].total_credit}}
                                </p>
                            </template>
                            <template #foot(slot_type)="data">
                                <span>

                                </span>
                            </template>
                            <template #foot(course_code)="data">
                                <span></span>
                            </template>
                            <template #foot(course_name)="data">
                                <span>
                                    {{$t('Completed ECTS')}}
                                </span>
                            </template>
                            <template #foot(status)="data">
                                <span></span>
                            </template>
                            <template #foot(details)="data">
                                <span></span>
                            </template>

                        </b-table>
                    </div>
                </template>
                <template v-else>
                    <div class="border rounded-sm p-4 mb-4 text-center">
                        {{ $t('no_result') }}
                    </div>
                </template>
            </div>

            <CommonModal ref="slotFormModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <span v-if="formProcess=='create'">{{ $t('new') }}</span>
                    <span v-if="formProcess=='update'">{{ $t('edit') }}</span>
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 :student-program-id="studentProgramId"
                                 :student-program-code="studentProgramCode"
                                 v-if="formProcess=='create'"
                    />
                    <update-form @updateFormSuccess="updateFormSuccess"
                                 :student-program-id="studentProgramId"
                                 :student-program-code="studentProgramCode"
                                 :form-id="formId"
                                 v-if="formProcess=='update'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="courseFormModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <span v-if="formProcess=='createCourse'">{{ $t('new') }}</span>
                    <span v-if="formProcess=='updateCourse'">{{ $t('edit') }}</span>
                </template>
                <template v-slot:CommonModalContent>
                    <create-course-form v-if="formProcess=='createCourse'"
                                        :slotId="slotId"
                                        :studentProgramId="studentProgramId"
                                        @createFormSuccess="createCourseFormSuccess"/>

                    <update-course-form v-if="formProcess=='updateCourse'"
                                        :slotId="slotId"
                                        :formId="formId"
                                        @updateFormSuccess="updateCourseFormSuccess"/>
                </template>
            </CommonModal>

        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

// Page
import CreateForm from './CreateForm'
import UpdateForm from './UpdateForm'
import CreateCourseForm from './course/CreateForm'
import UpdateCourseForm from './course/UpdateForm'

// Component
import CommonModal from '@/components/elements/CommonModal';
// Services
import StudentProgramService from '@/services/StudentProgramService'
import StudentSlotService from '@/services/StudentSlotService'
import StudentCourseService from '@/services/StudentCourseService'

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        CreateForm,
        UpdateForm,
        CreateCourseForm,
        UpdateCourseForm,
        CommonModal
    },
    metaInfo() {
        return {
            title: this.$t('student_slots')
        }
    },
    data() {
        return {
            // Loading
            loading: false,
            expandAllStatus: false,

            // Visible
            showExtraStudentInfo: true,

            // Student
            studentProgramId: null,
            studentProgramCode: null,
            groupSlot: [],
            semesters:[],
            student: {},
            studentCourseForm: null,

            // Filters
            filterStatus: false,
            filterSlotType: null,
            filterSlotTypes: [],
            filterStatusType: null,
            filterStatusTypes: [
                {value: null, text: this.$t('all')},
                {value: 1, text: this.$t('success')},
                {value: 2, text: this.$t('taking_during_active_semester')},
                {value: 3, text: this.$t('unsuccessful')},
                {value: 4, text: this.$t('not_taken')}
            ],

            // Slots
            slots: [],
            slotsFields: [
                {
                    key: 'process',
                    label: ' ',
                    class: 'w-40 p-1 align-middle'
                },
                {
                    key: 'responsive',
                    label: this.toUpperCase('slot'),
                    thClass: 'd-table-cell d-lg-none',
                    tdClass: 'd-table-cell d-lg-none'
                },
                {
                    key: 'semester',
                    label: this.toUpperCase('semester'),
                    thClass: 'd-none d-lg-table-cell text-center',
                    tdClass: 'd-none d-lg-table-cell align-middle text-center',

                },
                {
                    key: 'program_module_name',
                    label: this.toUpperCase('module_name'),
                    thClass: 'd-none d-lg-table-cell text-center',
                    tdClass: 'd-none d-lg-table-cell align-middle text-center'
                },
                {
                    key: 'slot_type',
                    label: this.toUpperCase('course_type'),
                    thClass: 'd-none d-lg-table-cell',
                    tdClass: 'd-none d-lg-table-cell align-middle',
                },
                {
                    key: 'course_code',
                    label: this.toUpperCase('course_code'),
                    thClass: 'd-none d-lg-table-cell',
                    tdClass: 'd-none d-lg-table-cell align-middle'
                },
                {
                    key: 'course_name',
                    label: this.toUpperCase('course_name'),
                    thClass: 'd-none d-lg-table-cell',
                    tdClass: 'd-none d-lg-table-cell align-middle'
                },
                {
                    key: 'credit',
                    label:this.changeText(this.$t('credit')).toUpper(),
                    thClass: 'd-none d-lg-table-cell text-center',
                    tdClass: 'd-none d-lg-table-cell text-center align-middle'
                },

                {
                    key: 'status',
                    label: this.toUpperCase('status'),
                    thClass: 'd-none d-lg-table-cell text-center',
                    tdClass: 'd-none d-lg-table-cell text-center'
                },
                {
                    key: 'detail',
                    label: ' ',
                    class: this.moveMode ? 'width-150 p-1 align-middle' : 'w-40 p-1 align-middle'
                }
            ],
            slotId: null,

            // Select & Detail
            slotsSelectIndex: null,
            slotsDetailsRow: null,

            // Move
            moveMode: false,
            moveFromSlotId: null,
            moveToSlotId: null,
            moveCourseId: null,

            // Form
            formProcess: null,
            formId: null
        }
    },
    created() {
        this.getUserData()

        this.studentProgramId = parseInt(this.$route.params.id)

        // Slots
        if (this.studentProgramId) {
            this.getSlots()
        } else {
            this.$router.push('/404');
        }
    },
    computed: {
        filteredSlots() {
            if (this.slots) {
                if (this.filterSlotType && this.filterStatusType) {
                    return this.slots.filter(item => {
                        return (item.slot_type.code.toLowerCase().indexOf(this.filterSlotType.toLowerCase()) > -1) && (item.slot_status == this.filterStatusType)
                    })
                }
                if (this.filterSlotType) {
                    return this.slots.filter(item => {
                        return item.slot_type.code.toLowerCase().indexOf(this.filterSlotType.toLowerCase()) > -1
                    })
                }
                if (this.filterStatusType) {
                    return this.slots.filter(item => {
                        return item.slot_status == this.filterStatusType
                    })
                }
                return this.slots;
            }
            return [];
        }
    },
    methods: {
        totalCredits(value1,value2){
            return value1 + value2
        },
        onRowClicked(item, index, event) {
            this.$set(item, '_showDetails', !item._showDetails);
            this.slotsDetailsRow = item._showDetails ? item : false;
            this.slotsSelectIndex = item._showDetails ? index : null;
        },
        expandAll() {
            this.expandAllStatus = true
            for (const item of this.slots) {
                this.$set(item, '_showDetails', true)
            }
        },
        setGroupSlot(){
            this.groupSlot=this.groupBy(this.slots,'semester')
            this.semesters=Object.keys(this.groupSlot)
            this.totalCreditAccount()
        },
        collapseAll() {
            this.expandAllStatus = false
            for (const item of this.slots) {
                this.$set(item, '_showDetails', false)
            }
        },
        totalCreditAccount(){
            Object.entries(this.groupSlot).forEach(([key, value]) => {
                let total = 0
                let successCreditTotal = 0
                total=value.reduce((acc, item) => Number(acc) +Number(item.credit), 0)
                value.forEach(item => {
                    if ([1].includes(item.slot_status)) {
                        successCreditTotal += Number(item.credit)
                    }
                })
                this.groupSlot[key].total_credit = successCreditTotal + ' / ' + total
            })
        },

        async getSlots() {
            this.loading = true
            await StudentProgramService.studentSlots(this.studentProgramId)
                .then((response) => {
                    this.student = response.data.data.student
                    this.studentProgramCode = this.student.program_code
                    this.slots = response.data.data.slots
                    this.setGroupSlot()
                    this.filterSlotTypes = [
                        {value: null, text: this.$t('all')}
                    ]
                    Object.values(response.data.data.slot_types).forEach(item => {
                        this.filterSlotTypes.push({
                            value: item.code,
                            text: item.name
                        })
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },

        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },

        // Slot
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.slotFormModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.slotFormModal.$refs.commonModal.hide()
            this.formClear();
            this.getSlots()
        },
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'update'
            this.$refs.slotFormModal.$refs.commonModal.show()
        },
        updateFormSuccess() {
            this.$refs.slotFormModal.$refs.commonModal.hide()
            this.formClear();
            this.getSlots()
        },
        deleteForm(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StudentSlotService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getSlots()
                            })
                            .catch(e => {
                                this.showErrors(e)
                            })
                    }
                })
        },

        // Course
        createCourseFormShow(slotId) {
            this.slotId = slotId
            this.formProcess = 'createCourse'
            this.$refs.courseFormModal.$refs.commonModal.show()
        },
        createCourseFormSuccess() {
            this.$refs.courseFormModal.$refs.commonModal.hide();
            this.formClear()
            this.getSlots()
        },
        updateCourseFormShow(slotId, id) {
            this.slotId = slotId
            this.formId = id
            this.formProcess = 'updateCourse'
            this.$refs.courseFormModal.$refs.commonModal.show()
        },
        updateCourseFormSuccess() {
            this.$refs.courseFormModal.$refs.commonModal.hide();
            this.formClear()
            this.getSlots()
        },
        deleteCourseForm(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StudentCourseService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getSlots()
                            })
                            .catch(e => {
                                this.showErrors(e)
                            })
                    }
                })
        },
        move(slot_id, course_id) {
            this.moveMode = true
            this.moveFromSlotId = slot_id
            this.moveCourseId = course_id
        },
        moveHere(slot_id) {
            this.moveToSlotId = slot_id
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_move'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StudentCourseService.move(this.moveCourseId, {student_slot_id: this.moveToSlotId})
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.moveCancel()
                                this.getSlots()
                            })
                            .catch(e => {
                                this.showErrors(e)
                            })
                    }
                })
        },
        moveCancel() {
            this.moveMode = false
            this.moveFromSlotId = null
            this.moveCourseId = null
            this.moveToSlotId = null
        },
        filterSlot(){
            let filterSlot=[];
            if (this.filterSlotType || this.filterStatusType) {
                filterSlot = this.slots.filter(item => {
                    const slotTypeMatch = this.filterSlotType ? item.slot_type.code === this.filterSlotType : true;
                    const statusMatch = this.filterStatusType ? item.slot_status === this.filterStatusType : true;

                    return slotTypeMatch && statusMatch;
                })
                this.groupSlot = this.groupBy(filterSlot, 'semester')
                this.semesters = Object.keys(this.groupSlot)
                this.totalCreditAccount()
            }
        },
        clearFilter(){
            this.filterSlotType = null
            this.filterStatusType = null
            this.setGroupSlot()
        },
        toggleProccessButton(permissionCode, item){
            if(this.checkPermission(permissionCode)){
                if(['PA','OI'].includes(this.userData.active_role.name) && this.userData.active_role.faculty_code == 50) {
                    if (['TP', 'P'].includes(item.slot_type.code)) {
                        return true
                    }
                } else if(['FS','ES','FSY','ESY'].includes(this.userData.active_role.name) && ['P'].includes(item.slot_type.code)) {
                    return false
                } else {
                    return true
                }
            }
            return false
        },
        getUserData() {
            this.$store.dispatch("auth/initUser")
            this.userData = this.$store.getters['auth/getUser']
        },
    }
}
</script>
<style>
.infos .progress {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.b-table-details {
    background: #f1f1f1 !important;
}
</style>
